<template>
  <div class="app-input-field">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'AppInputField',
}
</script>

<style scoped></style>
